export const QUESTION_TYPES_ID_MAPPING = {
  MULTIPLE_CHOICE: '1',
  QUANTITATIVE_COMPARISON: '2',
  NUMERIC_ENTRY: '3',
  MULTI_SELECT: '4',
  TEXT_COMPLETION: '5',
  FLASH_CARD: '6',
  ESSAY: '7',
  SENTENCE_SELECT: '8',
  TWO_PART_ANALYSIS: '12',
  TABLE_ANALYSIS: '11',
  MULTI_SOURCE_REASONING: '9',
  GRAPHICS_INTERPRETATION: '10',
  DATA_SIFFICIENCY: '13',
  PROBLEM_SOLVING: '14',
  CRITICAL_REASONING: '15',
  READING_COMPREHENSION: '16'
}

export const DISPLAY_TYPE_MAPPING = {
  MULTIPLE_CHOICE: '1'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/question-type/question-types-id.mapping.ts